import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookie } from "../contexts/CookieContext";

/**
 * Update analytics consent status — called by GTM Consent Mode v2
 * @param {string} status - 'granted' or 'denied'
 */
const updateConsent = (status) => {
  if (typeof window === "undefined" || !window.gtag) {
    return;
  }

  const normalizedStatus = status === "granted" ? "granted" : "denied";

  window.gtag("consent", "update", {
    analytics_storage: normalizedStatus,
    ad_storage: normalizedStatus,
    ad_user_data: normalizedStatus,
    ad_personalization: normalizedStatus,
    functionality_storage: normalizedStatus,
    personalization_storage: normalizedStatus,
  });
};

/**
 * Hook that manages GA4 consent and page-view events via GTM.
 * GTM loads the gtag.js script; this hook only sends consent updates and page_view events.
 */
const useGoogleAnalytics = () => {
  const location = useLocation();
  const { cookiePreferences } = useCookie();

  // Propagate user consent decision to GTM / GA4
  useEffect(() => {
    if (!window.gtag) return;

    if (cookiePreferences?.analytics === true) {
      updateConsent("granted");
    } else {
      updateConsent("denied");
    }
  }, [cookiePreferences?.analytics]);

  // Send page_view on route change (only when consent granted)
  useEffect(() => {
    if (cookiePreferences?.analytics && window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
      });
    }
  }, [location, cookiePreferences?.analytics]);
};

export default useGoogleAnalytics;
